import styled from "styled-components";
import DesignConstants from "../../../constants/DesignConstants";

export const ExerciseContentContainer = styled.div`
    background-color: ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    border-top: ${DesignConstants.BORDERS.THIN_GREY};
    padding: ${DesignConstants.SPACES.M};
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.M};

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        padding: ${DesignConstants.SPACES.S};
        gap: ${DesignConstants.SPACES.S};
    }
`;
